import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type InfoSheetProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
};

/** Bottom sheet inside the Snak for evidence and safety panels. */
export function InfoSheet({
  open,
  title,
  onClose,
  children
}: InfoSheetProps) {
  return <AnimatePresence data-id="element-515" data-mp="3qx8eop9ur2ym">
      {open && <>
          <motion.div key="scrim" className="absolute inset-0 z-20 bg-cap-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} data-id="element-516" data-mp="3vtgqptsr6g1k" />
          <motion.div key="sheet" role="dialog" aria-label={title} className="absolute inset-x-0 bottom-0 z-30 max-h-[88%] overflow-y-auto rounded-t-3xl border-t-4 border-cap-gold bg-white px-6 pb-6 pt-4 shadow-[0_-12px_40px_-12px_rgba(43,28,98,0.35)]" initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        duration: 0.32,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-517" data-mp="dovhv5pg8i92">
            <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-cap-line" aria-hidden="true" data-id="element-518" data-mp="1nwo1e1z79gbj" />
            <div className="flex items-center justify-between" data-id="element-519" data-mp="1ixbclborpz6b">
              <p className="text-[19px] font-extrabold tracking-[-0.02em] text-cap-purple" data-id="element-520" data-mp="1ez3x0k61j3wp">{title}</p>
              <button type="button" onClick={onClose} aria-label="Close panel" className="rounded-full p-1.5 text-cap-grey hover:text-cap-purple focus-visible:outline focus-visible:outline-2 focus-visible:outline-cap-gold" data-id="element-521" data-mp="2bms7cfzv1s5p">
                <XIcon size={18} data-id="element-522" data-mp="1xnsf6yd52v4s" />
              </button>
            </div>
            <div className="mt-3" data-id="element-523" data-mp="r8i0nq5ef82j">{children}</div>
          </motion.div>
        </>}
    </AnimatePresence>;
}